import React from "react";
import PropTypes from "prop-types";
import { MessageSquare } from "lucide-react";

const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  const date = new Date(dateString);
  return `${date.getDate().toString().padStart(2, "0")}/${(date.getMonth() + 1)
    .toString()
    .padStart(2, "0")}/${date.getFullYear()}`;
};

const CommentsCard = ({ comments }) => {
  if (!comments || comments.length === 0) return null;

  return (
    <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden w-full mb-6">
      <div className="bg-slate-50 px-6 py-3 border-b border-slate-100 flex items-center gap-2">
        <MessageSquare size={16} className="text-slate-500" />
        <h2 className="text-xs font-bold text-slate-700 uppercase tracking-wider">
          Approval Comments
        </h2>
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-slate-100">
          <thead className="bg-white">
            <tr>
              <th
                scope="col"
                className="px-6 py-3 text-left text-[10px] font-bold text-slate-400 uppercase tracking-wider"
              >
                Staff
              </th>
              <th
                scope="col"
                className="px-6 py-3 text-left text-[10px] font-bold text-slate-400 uppercase tracking-wider"
              >
                Comment
              </th>
              <th
                scope="col"
                className="px-6 py-3 text-left text-[10px] font-bold text-slate-400 uppercase tracking-wider"
              >
                Status
              </th>
              <th
                scope="col"
                className="px-6 py-3 text-left text-[10px] font-bold text-slate-400 uppercase tracking-wider"
              >
                Date
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-slate-100">
            {comments.map((comment) => (
              <tr
                key={comment.id}
                className="hover:bg-slate-50 transition-colors"
              >
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-slate-900">
                  {comment.staff.first_name} {comment.staff.last_name}
                </td>
                <td className="px-6 py-4 text-sm text-slate-600 max-w-xs break-words">
                  {comment.comment}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span
                    className={`inline-flex items-center px-2 py-0.5 rounded text-[10px] font-bold uppercase ${
                      comment.application_status === "APPROVED" ||
                      comment.application_status === "ACCEPTED"
                        ? "bg-green-50 text-green-700 border border-green-100"
                        : comment.application_status === "REJECTED" ||
                          comment.application_status === "DECLINED"
                        ? "bg-red-50 text-red-700 border border-red-100"
                        : "bg-gray-50 text-gray-700 border border-gray-100"
                    }`}
                  >
                    {comment.application_status}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-xs text-slate-500">
                  {formatDate(comment.created_at)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

CommentsCard.propTypes = {
  comments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      staff: PropTypes.shape({
        first_name: PropTypes.string,
        last_name: PropTypes.string,
      }),
      comment: PropTypes.string,
      application_status: PropTypes.string,
      created_at: PropTypes.string,
    })
  ),
};

export default CommentsCard;
